import { render, staticRenderFns } from "./HotpLink.vue?vue&type=template&id=3df9a19a&scoped=true"
import script from "./HotpLink.vue?vue&type=script&lang=js"
export * from "./HotpLink.vue?vue&type=script&lang=js"
import style0 from "./HotpLink.vue?vue&type=style&index=0&id=3df9a19a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df9a19a",
  null
  
)

export default component.exports